import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFileExcel, faFileWord, faFilter, faPlus, faPrint, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        liquidacionesInterventoria: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar la Liquidación de Interventoría?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("liquidaciones_interventoria/borrar/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        var status = datosRespuesta.data.status;
                        if (status) {
                            Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                            window.localStorage.clear();
                            window.location.href = '/';
                        }
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarLiquidacionesInterventoria(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarLiquidacionesInterventoria(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        let btipo_busqueda = document.getElementById('btipo_busqueda').value;
        if (bname == '') {
            bname = 0;
        }
        if (btipo_busqueda == '') {
            btipo_busqueda = 0;
        }
        authAxios.get("liquidaciones_interventoria/index/" + btipo_busqueda + "/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', liquidacionesInterventoria: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarLiquidacionesInterventoria(1);
    }
    render() {
        const { load, liquidacionesInterventoria, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddLiquidacionesInterventoria"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nueva Liquidación</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Liquidaciones Interventoría</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-2">
                                    <select name="btipo_busqueda" id="btipo_busqueda"
                                        className={"form-select form-select-sm"}
                                        onChange={this.cambioValor}>
                                            <option value="">-</option>
                                            <option value="periodo">PERIODO</option>
                                    </select>
                                </div>
                                <div className="col-xl-4">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="LIQUIDACIONES INTERVENTORÍA" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarLiquidacionesInterventoria(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">PERIODO LIQUIDACIÓN</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            liquidacionesInterventoria.map((itemLiquidacionesInterventoria) => (
                                                <tr key={itemLiquidacionesInterventoria.ID_LIQUIDACION_INTERVENTORIA}>
                                                    <td>{itemLiquidacionesInterventoria.PERIODO_LIQUIDACION}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <Link
                                                                className="btn btn-primary btn-sm"
                                                                to={"/UpLiquidacionesInterventoria/" + itemLiquidacionesInterventoria.ID_LIQUIDACION_INTERVENTORIA}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>&nbsp;&nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemLiquidacionesInterventoria.ID_LIQUIDACION_INTERVENTORIA)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>&nbsp;&nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-info btn-sm"
                                                                onClick={() =>
                                                                    this.descargarLiquidacion(itemLiquidacionesInterventoria.ID_LIQUIDACION_INTERVENTORIA)
                                                                }
                                                            >
                                                                <FontAwesomeIcon style={{color: '#FFFFFF'}} icon={faFileExcel} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarLiquidacionesInterventoria(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarLiquidacionesInterventoria(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarLiquidacionInterventoria(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarLiquidacionesInterventoria(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarLiquidacionesInterventoria(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;